import React, { useState, useEffect, useRef } from "react";
import ApiClient from "../services/api-client"
import IFramePrintTemplate from '../components/iframe-print-template.component';
import Modal from 'react-bootstrap/Modal';
import SelectTable from '../components/select-table'
import Commons from '../util/commons'
import AggridSalesTooltip from '../components/sales/aggridSalesTooltip'
import DateRangePickerInput from "../components/date-range-picker-input.js";
import Tippy from '@tippyjs/react';
import BlockUi from '@availity/block-ui';
import useStore from "../hooks/useStore";
import usePrintSaleBuilder from "../hooks/usePrintSaleBuilder.js";
import AllFieldsRenderer from "../components/aggrids/aggrid-cell-renderers/all-fields-renderer.js";
import MarkRenderer from "../components/aggrids/aggrid-cell-renderers/mark-renderer.js";
import SeriesNumberRendener from "../components/aggrids/aggrid-cell-renderers/seriesnumber-renderer.js";
import SaleActionsRenderer from "../components/aggrids/aggrid-cell-renderers/sale-action-renderer.js";
import CustomDateComponent from '../components/sales/customDateComponent.js';
import { AgGridReact } from 'ag-grid-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom'
import ReCAPTCHA from "react-google-recaptcha";
import AG_GRID_LOCALE_GR from '../locales/gr/aggrid-translation.js';
import AG_GRID_LOCALE_EN from '../locales/gb/aggrid-translation.js';
import { RECAPTCHA_KEY, API_BASE_URL } from '../util/constants';
import { toast } from 'react-toastify';
import { useForm, Controller } from "react-hook-form";
import { isMobile } from "react-device-detect";
import moment from 'moment-timezone'
import { useSSEMessageHandler } from "../hooks/useSSEMessageHandler";


export default function SaleSearch() {

    const navigate = useNavigate();
    const [gridApi, setGridApi] = useState(null);
    const [columnGridApi, setColumnGridApi] = useState(null);
    const { t, i18n } = useTranslation();
    const [printSale, setPrintSale] = useState("");
    const [currentPage, setCurrentPage] = useState(0);
    const [fastFilter, setFastFilter] = useState("");
    const [blockuiLoading, setBlockuiLoading] = useState(false);
    const [showEmailModal, setShowEmailModal] = useState(false);
    const [sendEmailIsDisabled, setSendEmailIsDisabled] = useState(true);
    const [selectedContactValue, setSelectedContactValue] = useState([]);
    const { control, setValue, getValues, formState: { errors } } = useForm();
    const [customerContacts, setCustomerContacts] = useState([]);
    const [selectedCustomerContacts, setSelectedCustomerContacts] = useState([]);
    const [lineData, setLineData] = useState({});
    const iframePrintTemplate = useRef();
    const pagination = true;
    const paginationPageSize = 20;
    const [sheight, setSheight] = useState(window.innerHeight - 190);
    const [sendPaymentLink, setSendPaymentLink] = useState(false);
    const [template, setTemplate] = useState(false);
    const [dismissSalesAlert, setDismissSalesAlert] = useState(false);
    const [touchStart, setTouchStart] = useState(null)
    const [touchEnd, setTouchEnd] = useState(null)
    const { buildPrintSale } = usePrintSaleBuilder();
    const [pinnedTotals, setPinnedTotals] = useState([]);
    const [aggridLocal, setAggridLocal] = useState(AG_GRID_LOCALE_GR);
    const recaptchaRef = useRef();

     useSSEMessageHandler();

    moment.tz.setDefault('Europe/Athens');

    const minSwipeDistance = 200

    const onTouchStart = (e) => {
        setTouchEnd(null) // otherwise the swipe is fired even with usual touch events
        setTouchStart(e.targetTouches[0].clientX)
    }

    const onTouchMove = (e) => {
        setTouchEnd(e.targetTouches[0].clientX)
    }

    const onTouchEnd = () => {
        var currentPage = gridApi.paginationGetCurrentPage();
        var lastpage = gridApi.paginationGetTotalPages();

        if (!touchStart || !touchEnd) return
        const distance = touchStart - touchEnd
        const isLeftSwipe = distance > minSwipeDistance
        const isRightSwipe = distance < -minSwipeDistance
        if (isLeftSwipe) {
            if (currentPage != lastpage) {
                gridApi.paginationGoToPage(currentPage + 1);
            }

        }
        else if (isRightSwipe) {
            if (currentPage != 0) {
                gridApi.paginationGoToPage(currentPage - 1);
            }
        }
    }

    const blockUi = (block) => {
        setBlockuiLoading(block)
    }

    var getPageObject = function () {
        var pageNo = gridApi.paginationGetCurrentPage();
        var sortBy = null;
        var order = "asc";
        var filterModel = gridApi.getFilterModel();
        console.debug(filterModel)
        columnGridApi.getColumnState().map((v) => {
            if (v.sort != null) {
                sortBy = v.colId;
                order = v.sort
            }
        });


        var simpleColumnFilters = [];
        Object.keys(filterModel).forEach(k => {
            var obj = {
                column: k,
                filter: filterModel[k].filter,
                dateFrom: filterModel[k].dateFrom,
                dateTo: filterModel[k].dateTo,
                filterType: filterModel[k].filterType,
                searchOperator: filterModel[k].type
            }
            if (obj.column == "seriesNumber") {
                obj.column = "series";
                obj.concatWith = "invoiceNumber";
            }
            simpleColumnFilters.push(obj);
        })


        var object = {
            "quickSearch": fastFilter,
            "pageNo": pageNo,
            "sortBy": sortBy,
            "order": order,
            "pageSize": paginationPageSize,
            "simpleColumnFilters": simpleColumnFilters
        }
        return object;
    }

    const getRowData = (params) => {
        var companyId = useStore.getState().selectedCompany.id;

        setTimeout(function () {
            gridApi.showLoadingOverlay();
        })
        var object = getPageObject();
        ApiClient.getCompanySaleInstancesPage(companyId, object).then(
            response => {

                const newSaleInstances = response.data.objectList.map(e => {
                    e.seriesNumber = e.series + e.invoiceNumber;
                    return e
                });

                params.successCallback(newSaleInstances, response.data.totalElements);

                const { totalWithoutVatSum, vatAmountSum, totalPaymentSum } = response.data;
                if (totalWithoutVatSum != null) {
                    setPinnedTotals([{
                        seriesNumber: t("Total"),
                        totalWithoutVat: totalWithoutVatSum,
                        totalWithVat: (totalWithoutVatSum || 0) + (vatAmountSum || 0),
                        totalPayment: totalPaymentSum,
                        mark: <></>
                    }]);
                } else {
                    setPinnedTotals([]);
                }

                if (newSaleInstances.length == 0) {
                    gridApi.showNoRowsOverlay();
                }
            },
            error => {
                gridApi.hideOverlay();
                console.error(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString())
            }
        );
    }

    useEffect(() => {

        if (gridApi) {
            const dataSource = {
                getRows: (params) => {
                    let mounted = true;
                    if (mounted) {
                        getRowData(params);
                    }
                    return () => mounted = false;
                }
            }
            let timer1 = setTimeout(function () {
                gridApi.setDatasource(dataSource);
            }, 1000);

            return () => {
                clearTimeout(timer1);
            };

        }
    }, [fastFilter]);




    useEffect(() => {

        var _defaults = Commons.getDefaults();
        if (_defaults) {
            var _dismissSalesAlert = Commons.getDefaults().dismissSalesAlert
            if (_dismissSalesAlert) {
                setDismissSalesAlert(true);
            }
        }

        if (gridApi) {
            const dataSource = {
                getRows: (params) => {
                    let mounted = true;
                    if (mounted) {
                        getRowData(params);
                    }
                    return () => mounted = false;
                }
            }

            if (i18n.language == "el-GR" || i18n.language == "gr") {
                setAggridLocal(AG_GRID_LOCALE_GR);
            } else {
                setAggridLocal(AG_GRID_LOCALE_EN);
            }

            gridApi.setDatasource(dataSource);

        }
    }, [gridApi]);



    const onGridReady = params => {
        setGridApi(params.api);
        setColumnGridApi(params.columnApi);
        window.addEventListener('resize', function () {
            setTimeout(function () {
                // params.api.sizeColumnsToFit();
                setSheight(window.innerHeight - 190);
            }, 300);
        });
    };
    const onQuickFilterChanged = e => {
        console.log();
        gridApi.fastFilter = e.target.value;
        setFastFilter(e.target.value.trim());

    };
    const onClickPrint = data => {
        console.log(data)
        setPrintSale(data)
        iframePrintTemplate.current.print(data)
    }

    const onPaginationChanged = (val) => {
        var currentPage = val.api.paginationGetCurrentPage();
        setCurrentPage(currentPage);
        val.api.hideOverlay();

    }
    const dateFormatter = (params) => {
        if (params.data?.invoiceDate) {
            return moment(params.data.invoiceDate, 'DD/MM/YYYY HH:mm:ssZZ').format('DD/MM/YYYY HH:mm');
        }
        return "";
    }
    const onChangeContact = data => {
        var recaptchaValue = recaptchaRef.current.getValue();

        setSelectedCustomerContacts(data);
        if (data && data.length > 0 && recaptchaValue && recaptchaValue != "") {
            setSelectedContactValue(data)
            setSendEmailIsDisabled(false)
        }
        else {
            setSendEmailIsDisabled(true)
        }
    }

    const onChangeCaptcha = (value) => {
        if (value && value != "" && selectedCustomerContacts.length > 0) {
            setSendEmailIsDisabled(false)
        }
        else {
            setSendEmailIsDisabled(true)
        }
    }


    function getContactEmails(sale, sendPaymentLink) {
        var customerName = sale.customeName;
        var _company = useStore.getState().selectedCompany;
        var subject = t("emailSubject", { company: _company.name });

        var contactEmails = [];
        selectedCustomerContacts.forEach(contact => {
            if (contact.email == undefined || contact.email == null) {
                contact.email = contact.value;
                contact.name = contact.value
            }
            var body = "<p>" + t("emailBody1", { contactName: contact.name }) + "</p>";
            body += "<p>" + t("emailBody2", { company: _company.name }) + "</p>";
            var link = "<a href='https://app.timologic.gr/mydata/" + sale.invoiceUid + "'>" + sale.invoiceType + " " + sale.series + sale.invoiceNumber + "</a>";
            body += "<p>" + t("emailBody3", { link: link }) + "</p>";

            if (sendPaymentLink && _company.vivaQuickPay) {
                body += "<p>" + t("emailVivaPayMess") + "</p>";
                body += "<p class='viva-pay-btn-cont'><a class='viva-pay-btn' href='" + _company.vivaQuickPay + "/" + sale.totalPayment + "'>" + t("payWithViva") + "</a></p>";
            }
            if (sendPaymentLink && _company.stripeAccountID) {
                var amount = sale.totalWithVat;
                body += "<p>" + t("emailStripePayMess") + "</p>";
                body += "<p class='stripe-pay-btn-cont'><a class='stripe-pay-btn' href='" + API_BASE_URL + "/stripe/checkout/" + _company.id + "?amount=" + amount + "&saleInstanceId=" + sale.id + "'>" + t("payWithTimologicPay") + "</a></p>";
            }
            contactEmails.push({
                subject: subject,
                body: body,
                email: contact.email
            });
        })
        return contactEmails;

    }
    const getPrintSale = (sale) => {
        const config = {
            nameFromNode: node => node.product.name,
            muFromNode: (node, t) => t(node.measurementUnit),
            whTaxFromNode: node => node.myDataWithHoldTaxes?.amountValue ?? "0.00",
            vatFromNode: node => node.vat.value,
            idFromNode: node => node.id,
            codeFromNode: node => node.productCode,

            // Additional issuer info from `sale` itself
            logo: sale.logo,
            issuerAddress: sale.branchAddress,
            issuerEmail: sale.issuerEmail,
            issuerPhone: sale.issuerPhone,
            subjectField: sale.issuerSubjectField,

            cancelmark: sale.cancellationMark,
            mark: sale.mark,

            // Optional overrides for company fields
            issuerName: sale.company?.name,
            senderName: sale.senderName,
            senderTaxpayerId: sale.senderTaxPayerId,
            recipientName: sale.recipientName,
            recipientTaxpayerId: sale.recipientTaxPayerId,
            customerName: sale.customerName,
            customerCode: sale.customerCode,
            customerCountry: sale.customerCountry,
        };
        return buildPrintSale(sale, config);
    }
    const onSendEmail = () => {
        var contactEmails = getContactEmails(lineData, sendPaymentLink);

        setTimeout(function () {
            setBlockuiLoading(true)
            try {
                var store = false;
                const user = useStore.getState().loggedInUser;
                var _company = useStore.getState().selectedCompany;

                const recaptchaValue = recaptchaRef.current.getValue();
                iframePrintTemplate.current._sendEmail({
                    contacts: contactEmails,
                    store: store,
                    companyId: _company.id,
                    taxpayerId: _company.taxpayerId,
                    fromEmail: user.email,
                    invoiceUid: lineData.invoiceUid,
                    captcha: recaptchaValue
                }, function (resp) {
                    setBlockuiLoading(false)
                    document.getElementById("template").style.display = "none";
                    setShowEmailModal(false);
                    if (resp.data.status == "SUCCESS") {
                        toast.success(t("emailSended"));
                    }
                    else {
                        toast.error(t("emailNotSended"));
                    }
                });
            }
            catch (e) {
                console.error(e)
                setBlockuiLoading(false)
            }
        })

    }

    const onInputChangeContact = (contact) => {

    }

    const exportToExcel = (e) => {
        e.preventDefault();
        var companyId = useStore.getState().selectedCompany.id;
        setBlockuiLoading(true)
        var object = getPageObject();
        ApiClient.exportCompanySalesToExcel(companyId, object).then(
            response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'export.xlsx');
                document.body.appendChild(link);
                link.click();
                setBlockuiLoading(false)
            },
            error => {
                console.error(
                    (error.response &&
                        error.response.data &&
                        error.response.data.message) ||
                    error.message ||
                    error.toString());
                setBlockuiLoading(false)
            }
        );
    }

    const pdfDownload = (_data) => {
        setPrintSale(_data)
        iframePrintTemplate.current.saveAsPDF(_data);
    }

    const pdfDownloadServer = (_data) => {
        iframePrintTemplate.current.saveAsPDFServerSide(_data);
    }

    return (
        <BlockUi tag="div" blocking={blockuiLoading}>
            <div className="container-fluid" style={{ padding: 0 }}>
                <div className="sales-page-header">
                    <h5 className="sales-page-title">
                        {t("invoicesSearch")}
                        <Tippy trigger="click" content={t("salesSearchInfo")}>
                            <i className="fa fa-info-circle"></i>
                        </Tippy>
                    </h5>
                    <div className="sales-toolbar">
                        <div className="sales-search-wrapper">
                            <i className="fa fa-search sales-search-icon"></i>
                            <input placeholder={t('Search')} className="form-control sales-search-input" id="searchSalesInput" onChange={onQuickFilterChanged} />
                        </div>
                        <div className="sales-toolbar-actions">
                            <button className="btn btn-skin btn-sm" onClick={() => navigate("/sale")}>
                                <i className="fa fa-plus"></i>
                                <span className="desktop-only"> {t("PublicationNew")}</span>
                            </button>
                            <button className="btn btn-skin btn-sm" title={t("exportToExcel")} onClick={exportToExcel}>
                                <i className="fa fa-file-excel-o"></i>
                            </button>
                        </div>
                        <div className="mobile-only">
                            <DateRangePickerInput gridApi={gridApi} />
                        </div>
                    </div>
                </div>
                <div className="sales-grid-wrapper">
                    {
                        !isMobile ?
                            <div
                                id="myGrid"
                                style={{ height: '100%', width: '100%' }}
                                className="ag-theme-alpine-dark sales-table-container"
                            >
                                <div className="ag-theme-alpine" style={{ height: sheight, width: '100%' }}>
                                    <AgGridReact
                                        pagination={pagination}
                                        paginationPageSize={paginationPageSize}
                                        onGridReady={onGridReady}
                                        // domLayout={'autoHeight'}
                                        style={{ width: '100%', height: '100%' }}
                                        // onRowDoubleClicked={(e) => goTo(e.data.invoiceUid)}
                                        // rowData={content}
                                        animateRows={true}
                                        pinnedBottomRowData={pinnedTotals}
                                        getRowStyle={params => params.node.rowPinned ? { fontWeight: '700' } : null}
                                        suppressRowTransform={true}
                                        localeText={aggridLocal}
                                        components={{
                                            aggridSalesTooltip: AggridSalesTooltip,
                                            agDateInput: CustomDateComponent,
                                        }}

                                        overlayNoRowsTemplate={
                                            '<span style="padding: 10px;  color:#013289">' + t('noEntries') + '</span>'
                                        }
                                        overlayLoadingTemplate={
                                            '<span class="ag-overlay-loading-center"><img src="loading.gif">' + t('aggridPageLoadMess') + '</span>'
                                        }
                                        onPaginationChanged={onPaginationChanged}
                                        rowModelType={'infinite'}
                                        cacheBlockSize={paginationPageSize}
                                        gridOptions={{ suppressMenuHide: true }}
                                        defaultColDef={{
                                            flex: 1,
                                            resizable: true,
                                            sortable: true,
                                            wrapText: true,
                                            suppressMovable: true,
                                            // autoHeight: true,
                                            icons: {
                                                menu: '<i style="color:white" class="fa fa-search"/>',
                                            },
                                        }}
                                        columnDefs={[
                                            { field: "id", hide: true },
                                            {
                                                field: "seriesNumber", flex: 1, minWidth: 120, headerName: t("Number"), sortable: true, filter: "agTextColumnFilter", cellRenderer: SeriesNumberRendener,
                                                filterParams: { buttons: ['reset', 'apply'] },
                                                cellRendererParams: {
                                                    printSale: printSale,
                                                    onClickPrint: onClickPrint,
                                                    blockUi: blockUi,
                                                    setShowEmailModal: setShowEmailModal,
                                                    setCustomerContacts: setCustomerContacts,
                                                    setLineData: setLineData,
                                                    getPrintSale: getPrintSale,
                                                    setTemplate: setTemplate,
                                                    pdfDownload: pdfDownload,
                                                    pdfDownloadServer: pdfDownloadServer
                                                }
                                            },
                                            { field: "invoiceDate", flex: 2, minWidth: 140, headerName: t("IssueDate"), sortable: true, filter: "agDateColumnFilter", valueFormatter: dateFormatter, cellClass: "cell-date", filterParams: { buttons: ['reset', 'apply'], inRangeInclusive: true } },
                                            { field: "customerName", flex: 5, minWidth: 200, headerName: t("Customer"), sortable: true, filter: "agTextColumnFilter", cellClass: "cell-customer", filterParams: { buttons: ['reset', 'apply'] } },
                                            { field: "customerTaxPayerId", flex: 2, minWidth: 140, headerName: t("taxpayerId"), sortable: true, filter: "agTextColumnFilter", cellClass: "cell-taxid", filterParams: { buttons: ['reset', 'apply'] } },
                                            { field: "invoiceTypeName", flex: 5, tooltipField: "invoiceType", minWidth: 220, headerName: t("InvoiceType"), sortable: true, filter: "agTextColumnFilter", cellClass: "cell-invtype", filterParams: { buttons: ['reset', 'apply'] } },
                                            { field: "totalWithoutVat", flex: 2, minWidth: 100, valueFormatter: function (params) { return params.data != null ? params.data.totalWithoutVat.toFixed(2) : 0.00 }, headerName: t("TotalWithoutVat"), sortable: true, filter: "agNumberColumnFilter", cellClass: "cell-amount", filterParams: { buttons: ['reset', 'apply'] } },
                                            { field: "totalWithVat", flex: 2, minWidth: 100, valueFormatter: function (params) { return params.data != null ? (params.data.totalWithVat - params.data.totalWithoutVat).toFixed(2) : 0.00 }, headerName: t("VatAmount"), sortable: true, filter: "agNumberColumnFilter", cellClass: "cell-amount", filterParams: { buttons: ['reset', 'apply'] } },
                                            { field: "totalPayment", flex: 2, minWidth: 100, valueFormatter: function (params) { return params.data != null ? params.data.totalPayment.toFixed(2) : 0.00 }, headerName: t("TotalPayment"), sortable: true, filter: "agNumberColumnFilter", cellClass: "cell-amount cell-total", filterParams: { buttons: ['reset', 'apply'] } },
                                            { field: "mark", flex: 2, minWidth: 150, headerName: t("myDATA MARK"), sortable: true, filter: "agNumberColumnFilter", filterParams: { buttons: ['reset', 'apply'] }, cellClass: "cell-mark", cellRenderer: MarkRenderer },
                                            { field: "cancelationMark", headerName: t("myDATA MARK"), hide: true },
                                            {
                                                field: "action", flex: 1, minWidth: 100, headerName: t("Actions"), cellRenderer: SaleActionsRenderer,
                                                cellRendererParams: {
                                                    printSale: printSale,
                                                    onClickPrint: onClickPrint,
                                                    blockUi: blockUi,
                                                    setShowEmailModal: setShowEmailModal,
                                                    setCustomerContacts: setCustomerContacts,
                                                    setLineData: setLineData,
                                                    getPrintSale: getPrintSale,
                                                    setTemplate: setTemplate,
                                                    pdfDownload: pdfDownload,
                                                    pdfDownloadServer: pdfDownloadServer
                                                }
                                            }
                                        ]}
                                    >
                                    </AgGridReact>
                                </div>
                                <IFramePrintTemplate style={{ width: 800, height: "297mm", left: 0, top: 0, position: "fixed", zIndex: -100 }} extracss={template.css} template={template} ref={iframePrintTemplate} ></IFramePrintTemplate>

                            </div>
                            :

                            <div
                                id="myGrid"
                                onTouchStart={onTouchStart} onTouchMove={onTouchMove} onTouchEnd={onTouchEnd}
                                style={{ height: '100%', width: '100%' }}
                                className="ag-theme-alpine-dark sales-mobile-table-container"
                            >
                                <div className="ag-theme-alpine" style={{ height: sheight, width: '100%' }}>
                                    <AgGridReact
                                        pagination={pagination}
                                        paginationPageSize={paginationPageSize}
                                        onGridReady={onGridReady}
                                        // domLayout={'autoHeight'}
                                        style={{ width: '100%', height: '100%' }}
                                        // onRowDoubleClicked={(e) => goTo(e.data.invoiceUid)}
                                        // rowData={content}
                                        // domLayout={'autoHeight'}
                                        animateRows={true}
                                        suppressCellSelection={true}
                                        suppressRowTransform={true}
                                        localeText={aggridLocal}
                                        components={{
                                            aggridSalesTooltip: AggridSalesTooltip,
                                            agDateInput: CustomDateComponent,
                                        }}
                                        overlayNoRowsTemplate={
                                            '<span style="padding: 10px;  color:#013289">' + t('noEntries') + '</span>'
                                        }
                                        overlayLoadingTemplate={
                                            '<span className="ag-overlay-loading-center"><img src="loading.gif">' + t('aggridPageLoadMess') + '</span>'
                                        }
                                        rowHeight={86}
                                        onPaginationChanged={onPaginationChanged}
                                        rowModelType={'infinite'}
                                        cacheBlockSize={paginationPageSize}
                                        gridOptions={{ suppressMenuHide: true }}
                                        tooltipHideDelay={0}
                                        enableBrowserTooltips={false}
                                        defaultColDef={{
                                            sortable: true,
                                            wrapText: false,
                                            suppressHorizontalScroll: true,
                                            suppressMovable: true,
                                        }}
                                        columnDefs={[
                                            { field: "id", hide: true, sort: "desc" },
                                            { field: "invoiceTypeName", flex: 5, headerName: t(""), sortable: true, filter: "agTextColumnFilter", cellRenderer: AllFieldsRenderer },
                                            { field: "invoiceDate", flex: 1, minWidth: 140, headerName: t("DateTime"), hide: true, sortable: true, filter: "agDateColumnFilter", valueFormatter: dateFormatter, filterParams: { inRangeInclusive: true } },
                                            { field: "mark", flex: 2, minWidth: 150, headerName: t("myDATA MARK"), sortable: true, hide: true, filter: "agNumberColumnFilter", filterParams: { buttons: ['reset', 'apply'] }, cellRenderer: MarkRenderer },
                                            { field: "cancelationMark", headerName: t("myDATA MARK"), hide: true },
                                            {
                                                field: "action", flex: 0.5, headerName: t(""), cellRenderer: SaleActionsRenderer,
                                                cellRendererParams: {
                                                    printSale: printSale,
                                                    onClickPrint: onClickPrint,
                                                    blockUi: blockUi,
                                                    setShowEmailModal: setShowEmailModal,
                                                    setCustomerContacts: setCustomerContacts,
                                                    setLineData: setLineData,
                                                    getPrintSale: getPrintSale,
                                                    setTemplate: setTemplate,
                                                    pdfDownload: pdfDownload,
                                                    pdfDownloadServer: pdfDownloadServer
                                                }
                                            }
                                        ]}
                                    >
                                    </AgGridReact>
                                </div>
                                <IFramePrintTemplate style={{ width: 800, height: "297mm", left: 0, top: 0, position: "fixed", zIndex: -100 }} extracss={template.css} template={template} ref={iframePrintTemplate} ></IFramePrintTemplate>

                            </div>

                    }
                </div>
            </div >
            <Modal
                aria-labelledby="contained-modal-title-vcenter"

                centered
                show={showEmailModal}
                dialogClassName="email-modal"
                backdrop="static"
                className="send-email-modal"
                keyboard={false}
            >
                <Modal.Header >
                    <Modal.Title>{t("sendEmail")}</Modal.Title>

                </Modal.Header>
                <Modal.Body>
                    <span className="totalConstraintInfo"></span>
                    <div className="row">
                        <div className="col-md-12 selectInputContainer form-group">
                            <label className="control-label inputlabel">{t("customerContacts")}
                                <i data-tip data-for="ccInfo" className="fa fa-x2 fa-info-circle infoicon" data-bs-toggle="tooltip" data-bs-placement="top"></i>

                                <Tippy trigger="click" content={t("ccInfo2")}>
                                    <i className="fa fa-x2 fa-info-circle infoicon"></i>
                                </Tippy>
                            </label>
                            <Controller
                                render={({ field }) => (
                                    <SelectTable {...field}
                                        inputId="contacts-react-select"
                                        onChange={onChangeContact}
                                        onChangeValue={onChangeContact}
                                        // selectedValue={selectedContactValue}
                                        // inputValue={inputContactValue}
                                        onInputChange={onInputChangeContact}

                                        isMulti={true}
                                        options={customerContacts}
                                        createTable={true}
                                        className={`form-control ${errors.customerContact ? 'is-invalid' : ''}`}
                                        placeholder={t('Select')}
                                        width={500}
                                    >

                                    </SelectTable>
                                )}
                                control={control}
                                name="customerContacts"
                                defaultValue=""
                            />
                            <br></br>
                            <input type="checkbox" onChange={e => setSendPaymentLink(e.target.checked)} name="sendPaymentLink" checked={sendPaymentLink} className="form-check-input" />{t("sendPaymentLink")}
                            <div className="form-item text-center recapctha-container">
                                <ReCAPTCHA
                                    ref={recaptchaRef}
                                    sitekey={RECAPTCHA_KEY}
                                    onChange={onChangeCaptcha}
                                    size="compact"
                                    hl="el"
                                />
                            </div>
                            <div className="invalid-feedback">{errors.customerContact?.message}</div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn btn-skin btn-sm" onClick={function () { setSendEmailIsDisabled(true); setShowEmailModal(false) }}>{t("cancel")}</button>
                    <button id="onExtras" className="btn btn-skin btn-sm" disabled={sendEmailIsDisabled} onClick={onSendEmail}>{t("send")}</button>
                </Modal.Footer>
            </Modal>
        </BlockUi >
    );
}


